import { Checkbox, FormControlLabel } from "@mui/material"
import { useDispatch } from "react-redux"
import { setItemWebStorage } from "../../../../../features/webStorageSaver"
import { useAppSelector } from "../../../../../stateManagement/hooks/redux"
import { setTransportMonitoringShowNumbers } from "../../../../../stateManagement/reducers/transport/TransportNowSlice"


export default function TransportNowOverlay() {
    const dispatch = useDispatch()

    const transportMonitoringShowNumbers = useAppSelector(state => state.transportNow.transportMonitoringShowNumbers)

    function onCheckTransportMonitoringShowNumbers(event: any) {
        setItemWebStorage('transportMonitoringShowNumbers', event.target.checked)
        dispatch(setTransportMonitoringShowNumbers(event.target.checked))
    }

    return (
        <>
            <div className="map-overlay map-overlay-transport-now">
                <div className="server-state-display" >
                    <div className="server-status-circle disconnected" />
                    EGTS сервер
                </div>
                <div className="show-transport-numbers-display">
                    <FormControlLabel
                        className="check-string"
                        key={`transportNowNumbers`}
                        checked={transportMonitoringShowNumbers}
                        name={`transportNowNumbers`}
                        onChange={(event: any) => onCheckTransportMonitoringShowNumbers(event)}
                        color="black"
                        control={<Checkbox className="ch-white" style={{ color: 'white' }} />}
                        label="Номера"
                    />
                </div>
            </div>
        </>
    )
}
